import { IconButton, Tooltip } from "@/components";

import { ReactNode } from "react";
import clsx from "clsx";

export type MapToolBoxEntryProps<T = string> = {
  text: string;
  mode: T;
  icon: ReactNode;
  onSelect: (mode: T) => void;
  selected: boolean;
  disabled?: boolean;
};

export const MapToolBoxEntry = <T = string,>({
  text,
  mode,
  icon,
  onSelect,
  selected,
  disabled = false,
}: MapToolBoxEntryProps<T>) => {
  const className = selected ? "bg-primary-active" : "bg-primary";

  return (
    <div className="py-1" key={"toolbox-" + mode}>
      <div className="rounded-md bg-primary w-10 h-10">
        <Tooltip label={text} pos="right" arrow>
          <IconButton
            onClick={() => onSelect(mode)}
            className={clsx(
              "border-transparent text-secondary rounded-md w-10 h-10 hover:bg-primary-active",
              className,
            )}
            disabled={disabled}
          >
            {icon}
          </IconButton>
        </Tooltip>
      </div>
    </div>
  );
};
